import Controls from "../../containers/searchpage/controls";
import Helmet from "react-helmet";
import IdxReqs from "../shared/idx/idx-reqs";
import ListView from "./list-view";
import NoResults from "./no-results";
import objectAssign from "object-assign";
import PhotoView from "./photo-view";
import React from "react";
import request from "superagent";
import ResultsFooter from "./results-footer";
import ResultsHeader from "./results-header";
import {
  getEntityLabel,
  getSortField,
  loadCookie,
  parsePage,
  modifyFilter,
  parseBannerFilter,
  getCorrectOffSalesRegion,
} from "../shared/util";
import _ from "lodash";

import "./search.scss";
import "./results.scss";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        activePage: parsePage(props),
        idxExclusions: props.entity.siteOptions.idxExclusions,
        regionUrlPart: props.params.region,
        resultsPerPage: loadCookie("aw_results_per_page", [12, 24, 60], 24),
        bannerFilter: parseBannerFilter(props) || "all",
        sortDirection: "desc",
        sortField: getSortField(props),
        listingType: "sale",
      },
      results: [],
      resultCount: 0,
      startCount: 0,
      endCount: 0,
      view: "photo",
      searchResults: [],
      isLoading: false,
    };
  }

  changeView = (viewName) => {
    this.setState({ view: viewName });
  };

  changeFilter = (name, value) => {
    let filter = modifyFilter(this.state.filter, name, value);
    this.setState({ filter: filter }, () => {
      this.fetchResults();
    });
  };

  mergeFilter = (filter, url) => {
    var currentFilter = this.state.filter;
    currentFilter.activePage = 1;
    if (!url) {
      delete currentFilter.postalTown;
      delete currentFilter.neighborhood;
      delete currentFilter.listingSearch;
    }
    const updatedFilter = objectAssign(currentFilter, filter);
    this.setState(
      {
        filter: updatedFilter,
      },
      this.fetchResults(url, updatedFilter)
    );
  };

  clearResults = () => {
    this.setState({ searchResults: [] });
  };

  fetchResults = (url, updatedFilter) => {
    let filter = updatedFilter ? updatedFilter : this.state.filter;
    if (!url) {
      delete filter.searchKey;
    }
    if (url) {
      delete filter.neighborhood;
      delete filter.postalTown;
      this.setState({ isLoading: true });
    }
    this.request = request
      .post(url ? url : "/api/listings")
      .set("Content-Type", "application/json")
      .send(filter)
      .end((error, response) => {
        if (response && response.body) {
          if (url) {
            this.setState({
              searchResults: _.groupBy(response.body.results, "key"),
              isLoading: false,
            });
          } else {
            this.setState(response.body, () => {
              sessionStorage.setItem(
                this.props.params.region + "-prevnext",
                JSON.stringify(this.state.ids)
              );
            });
          }
        } else {
          console.error(error);
        }
      });
  };

  componentWillReceiveProps(nextProps) {
    let activePage = parsePage(nextProps);
    let updatedFilter = this.state.filter;
    if (activePage !== updatedFilter.activePage) {
      updatedFilter.activePage = activePage;
      this.setState(
        {
          filter: updatedFilter,
        },
        this.fetchResults()
      );
    }
  }

  componentWillUnmount() {
    if (this.request) {
      this.request.abort();
    }
  }

  render() {
    const title = `${getCorrectOffSalesRegion(
      this.props.entity
    )} Luxury Real Estate for ${
      this.props.params.listingType === "sales" ? "Sale" : "Rent"
    } | ${this.props.entity.brand}, Inc.`;
    return (
      <div className={"search-results " + this.props.params.listingType}>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`View luxury real estate and homes for ${
              this.props.params.listingType === "sales" ? "sale" : "rent"
            } from ${this.props.entity.brand} ${getEntityLabel(
              this.props.entity
            ).toLowerCase()} ${
              this.props.entity.displayName
            } in ${getCorrectOffSalesRegion(
              this.props.entity
            )}. Get details, photos, videos & more.`}
          />
        </Helmet>
        <Controls
          config={this.props.config}
          entity={this.props.entity}
          params={this.props.params}
          mergeFilter={this.mergeFilter}
          location={this.props.location} //check from where its coming
          route={this.props.route} //check from where its coming
          region={this.props.entity.region}
          resetBannerFilter={this.changeFilter.bind(
            this,
            "bannerFilter",
            "all"
          )}
          bannerFilter={this.state.filter.bannerFilter}
          count={this.props.count} //check from where its coming
          searchResults={this.state.searchResults}
          isLoading={this.state.isLoading}
          clearResults={this.clearResults}
        />
        <ResultsHeader
          regionUrl={this.props.params.region}
          resultState={this.state}
          changeView={this.changeView}
          changeFilter={this.changeFilter}
          params={this.props.params}
          location={this.props.location}
        />
        <div
          id="search-listing-tabpanel"
          role="tabpanel"
          aria-labelledby="search-sales-tab search-rentals-tab"
          tabIndex="0"
        >
          {this.state.view === "photo" ? (
            <PhotoView results={this.state.results} />
          ) : null}
          {this.state.view === "list" ? (
            <ListView results={this.state.results} />
          ) : null}
          {this.state.resultCount === 0 ? (
            <NoResults filter={this.state.filter} />
          ) : null}
          <ResultsFooter
            resultState={this.state}
            changeFilter={this.changeFilter}
            params={this.props.params}
            location={this.props.location}
          />
        </div>
        <div className="container">
          <IdxReqs mlsOrgs={this.state.mlsOrgs} config={this.props.config} />
        </div>
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/search/search.jsx